
<template>
  <div class="protocl-container">

    <van-checkbox v-model="dataIsAgree" class="custom-checkbox">{{ $t('登录授权提示', [platform]) }}
       <template #icon="props">
       <img class="img-icon" :src="props.checked ? checkbox_checked : checkbox_unchecked" />
        </template>
    </van-checkbox>

    <van-checkbox v-model="dataIsPlatformAgree" class="custom-checkbox"> {{ $t('已阅读并同意')}}
      <span class="link" @click.stop="goLink('https://app-ctc.viomi.com.cn/etc/agreement?protocolId=101361')"> {{ $t('《用户协议》')}}</span>
       {{ $t('和')}}
       <span class="link" @click.stop="goLink('https://app-ctc.viomi.com.cn/etc/agreement?protocolId=101360')">{{ $t('《隐私政策》')}}</span>
       {{ isSmsLogin ? $t('，如该手机未注册，则直接为你注册为新用户') : ''}}
       <div> {{ $t('同意该应用获得以下权限')}} </div>
       <template #icon="props">
      <img class="img-icon" :src="props.checked ? checkbox_checked : checkbox_unchecked" />
      </template>
      </van-checkbox>

      <ul>
        <li>{{ $t('授权账号头像信息')}}</li>
        <li>{{ $t('授权智能设备信息')}}</li>
      </ul>

    </div>
</template>
<script>
export default {
  name: 'ProtocolView',
  model: {
    prop: 'isAgree',
    event: 'change'
  },
  props: {
    isPlatformAgree: {
      type: Boolean,
      default: false
    },
    isSelfAgress: {
      type: Boolean,
      default: false
    },
    isAgree: {
      type: Boolean,
      default: false
    },
    isSmsLogin: {
      type: Boolean,
      default: false
    },
    platform: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      checkbox_checked: require('@/icons/checkbox_checked.png'),
      checkbox_disabled: require('@/icons/checkbox_disable.png'),
      checkbox_unchecked: require('@/icons/checkbox_uncheck.png'),
      dataIsAgree: this.isSelfAgress,
      dataIsPlatformAgree: this.isPlatformAgree,
      dataTotalAgree: this.isSelfAgress && this.isPlatformAgree
    }
  },
  watch: {
    isSelfAgress: function(newValue, oldValue) {
      this.dataIsAgree = newValue
    },
    isPlatformAgree: function(newValue, oldValue) {
      this.dataIsPlatformAgree = newValue
    },
    dataIsAgree: function(newValue, oldValue) {
      this.dataTotalAgree = newValue && this.dataIsPlatformAgree
    },
    dataIsPlatformAgree: function(newValue, oldValue) {
      this.dataTotalAgree = newValue && this.dataIsAgree
    },
    dataTotalAgree: function(newValue, oldValue) {
      this.$emit('change', newValue)
    }
  },
  methods: {
    goLink(url) {
      this.$emit('clickProtocol', url)
    }
  }
}
</script>

<style lang="less" scoped>
  .protocl-container {
    // position: absolute;
    // left:28px;
    // right: 28px;
    // bottom: 10px;
    margin-top: 40px;
    margin-bottom: 40px;
    color: gray;
    font-size: 10px;
    .custom-checkbox {
      margin-bottom: 5px;
      .img-icon {
        width: 16px;
        height: 16px;
      }
    }
    .custom-checkbox /deep/ .van-checkbox__label {
        color: gray;
        line-height: 16px;
        white-space: normal;
      }

    .custom-checkbox /deep/ .van-checkbox__icon {
      align-self: center;
      line-height: 16px;
      width: 16px;
      height: 16px;
    }

    .custom-checkbox-disable {
      margin-bottom: 5px;
      .img-icon {
        width: 16px;
        height: 16px;
      }
    }

    ul {
      padding-left: 22px;
      margin-left: 0;
    }
    li {
      list-style-type: disc;
    }

    .custom-checkbox-disable /deep/ .van-checkbox__label {
        color: gray;
        line-height: 16px;
        white-space: normal;
      }
     .custom-checkbox-disable /deep/ .van-checkbox__icon {
      align-self: center;
      line-height: 16px;
      width: 16px;
      height: 16px;
    }
    .link {
    color: #2C2C2C;
    }
  }
</style>
